module.exports = __webpack_public_path__ + "static/media/thumbnail-ipo.797c17e4.png";